module.exports = __webpack_public_path__ + "img/reboot_icon.85b7509d.svg";